import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import styled from 'styled-components';
import { CircularLoader } from '../circular-loader';
import { useHapticFeedback } from '../native';
import { adjustIconSize, resolveButtonContent } from './button-content';
import { buttonShapeCss, ghostCss, glass2Css, gradientCss, secondaryCss, softCss, solidCss, } from './button-styles';
import { glassCss } from './button-styles-glass';
import { BUTTON_FONT_SIZE_MAP, BUTTON_PADDING_MAP, BUTTON_RADIUS_MAP_ROUNDED, LOADER_SIZE_MAP, } from './constants';
export const Button = ({ color = 'background', size = 's', variant = 'solid', busy = false, fullWidth = false, radius = 'full', disabled, gradient, children, iconLeft, iconRight, onClick, className, ref, ...props }) => {
    const haptics = useHapticFeedback();
    const handleClick = (e) => {
        if (onClick) {
            haptics.impactOccurred('light');
            onClick(e);
        }
    };
    const buttonContent = resolveButtonContent({
        children,
        iconLeft,
        iconRight,
    });
    const loaderSize = LOADER_SIZE_MAP[size];
    const renderContent = () => {
        if (busy) {
            const loaderColor = (() => {
                if (variant === 'solid') {
                    return color === 'gray' ? 'gray-inverse' : 'gray';
                }
                if (variant === 'glass-2') {
                    return color;
                }
                return 'gray';
            })();
            return _jsx(CircularLoader, { size: loaderSize, color: loaderColor });
        }
        if (buttonContent.type === 'OnlyIcon') {
            return adjustIconSize(buttonContent.icon, size);
        }
        return (_jsxs(_Fragment, { children: [adjustIconSize(iconLeft, size), children, adjustIconSize(iconRight, size)] }));
    };
    return (_jsx(Root
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    , { 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: ref, "$variant": variant, "$color": color, "$size": size, "$gradient": gradient, "$fullWidth": fullWidth, "$loading": busy, "$onlyIcon": buttonContent.type === 'OnlyIcon', "$radius": radius, disabled: disabled, onClick: handleClick, type: "button", "data-busy": busy, className: clsx(className, {
            'radius-rounded': radius === 'rounded',
            'radius-full': radius === 'full',
        }), ...props, children: renderContent() }));
};
const Root = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  background: transparent;
  text-decoration: none;

  gap: 5px;
  font-weight: 700;
  white-space: nowrap;
  transition: all 100ms ease-in;

  font-size: ${({ $size }) => BUTTON_FONT_SIZE_MAP[$size]}px;
  border-radius: ${({ $size }) => BUTTON_RADIUS_MAP_ROUNDED[$size]}px;

  &.radius-rounded {
    border-radius: ${({ $size }) => BUTTON_RADIUS_MAP_ROUNDED[$size]}px;
  }

  &.radius-full {
    border-radius: var(--button-radius-full);
  }

  padding-inline: ${({ $onlyIcon, $size }) => $onlyIcon ? 0 : BUTTON_PADDING_MAP[$size]}px;

  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};

  ${(props) => buttonShapeCss(props)}
  ${(props) => {
    const { $variant } = props;
    if ($variant === 'solid') {
        return solidCss(props);
    }
    if ($variant === 'secondary') {
        return secondaryCss(props);
    }
    if ($variant === 'gradient') {
        return gradientCss(props);
    }
    if ($variant === 'soft') {
        return softCss(props);
    }
    if ($variant === 'ghost') {
        return ghostCss(props);
    }
    if ($variant === 'glass') {
        return glassCss(props);
    }
    if ($variant === 'glass-2') {
        return glass2Css(props);
    }
}}
`;
//# sourceMappingURL=button.js.map